export default __webpack_public_path__ + "static/media/madurai1.76324d57.jpg";